import { getDeepLinkProtocol } from '@/utils/platform';

export const DOWNLOAD_URL = 'https://littlebird.ai/download';
const DEEP_LINK_TIMEOUT = 2500;

interface TriggerDeepLinkOptions {
  params?: Record<string, string>;
  onFallback?: () => void;
  fallbackUrl?: string;
}

/**
 * Triggers a deep link to the desktop app. On Mac, uses hidden iframe approach
 * with blur-based detection. Falls back to download page if app doesn't open.
 */
export function triggerDeepLink(
  path: string,
  options?: TriggerDeepLinkOptions
): void {
  const protocol = getDeepLinkProtocol();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  let deepLinkUrl = `${protocol}://open${normalizedPath}`;

  if (options?.params && Object.keys(options.params).length > 0) {
    const searchParams = new URLSearchParams(options.params);
    deepLinkUrl += `?${searchParams.toString()}`;
  }

  const fallbackUrl = options?.fallbackUrl ?? DOWNLOAD_URL;

  // Deep links only work on Mac
  if (!/Macintosh|Mac OS X/i.test(navigator.userAgent)) {
    window.location.href = fallbackUrl;
    return;
  }

  let didBlur = false;
  const handleBlur = () => {
    didBlur = true;
  };
  window.addEventListener('blur', handleBlur);

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = deepLinkUrl;
  document.body.appendChild(iframe);

  setTimeout(() => {
    window.removeEventListener('blur', handleBlur);
    if (iframe.parentNode) {
      document.body.removeChild(iframe);
    }

    if (!didBlur) {
      if (options?.onFallback) {
        options.onFallback();
      } else {
        window.location.href = fallbackUrl;
      }
    }
  }, DEEP_LINK_TIMEOUT);
}
